import React from "react";
import { NavLink } from "react-router-dom";
import "./styles.css";

const Nav = () => {
  return (
    <nav>
      <NavLink to="/" exact className="subpage-tab" activeClassName="selected">
        Overview
      </NavLink>

      <NavLink
        to="/donor-incentives"
        className="subpage-tab"
        activeClassName="selected"
      >
        Donor Incentives
      </NavLink>

      <NavLink
        to="/charity-incentives"
        className="subpage-tab"
        activeClassName="selected"
      >
        Charity Incentives
      </NavLink>

      <NavLink
        to="/tools-resources"
        className="subpage-tab"
        activeClassName="selected"
      >
        Tools & Resources
      </NavLink>

      <NavLink
        to="/participating-charities"
        className="subpage-tab"
        activeClassName="selected"
      >
        Participating Charities
      </NavLink>
    </nav>
  );
};

export default Nav;
